import { render } from "lit-html";
import { translate } from "@escapio/shared/l10n/translate";
import { onChangeAny } from "@escapio/portal/state/travelData";
import bookingdotcomInvertedSvg from "@docroot/public/img/portal/adaptive/bookingdotcom_inverted.svg";
import { formatBookingRedirectUrl } from "@escapio/portal/components/format-booking-redirect-url";
import { templateTextAndButton } from "./partner-banner";

customElements.define(
	"esc-booking-banner",
	class extends HTMLElement {
		connectedCallback() {
			this.render();
			onChangeAny(this.render.bind(this));
		}

		render() {
			render(
				templateTextAndButton(
					"Liste",
					"Booking Banner",
					`${this.trackingId} | ${this.title}`,
					this.redirectUrl,
					this.title,
					translate("hotel_list_booking_first_line"),
					translate("hotel_list_booking_second_line"),
					translate("list_booking_banner_button_aria_label"),
					bookingdotcomInvertedSvg,
				),
				this,
			);
		}

		get redirectUrl() {
			return formatBookingRedirectUrl(
				this.getAttribute("redirect-endpoint"),
				this.getAttribute("token"),
				"Liste-Banner",
			);
		}

		get title() {
			return this.getAttribute("title");
		}

		get trackingId() {
			return this.getAttribute("tracking-id");
		}
	},
);
